import {switchMap} from "rxjs/operators";
import {ofType} from "redux-observable";

import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as componentTypes from "../constants/componentTypes";
import * as handlers from "../constants/handlers";
import * as settings from "../constants/settings";
import * as getterHelper from "../helpers/getterHelper";

const loadHistoryOrder = (action$, state$) =>
    action$.pipe(
        ofType(actionTypes.INTERGAMMA_LOAD_HISTORY_ORDER),
        switchMap(({payload}) => {
            if (payload.qrCode === null) {
                return [];
            }

            let formulaTab = null;

            for (let tab of state$.value.navigation.tabList) {
                if (getterHelper.isFormulaTab(tab.type)) {
                    formulaTab = tab;
                }
            }

            if (formulaTab === null) {
                return [];
            }

            return [
                {
                    type: actionTypes.SET_ACTIVE_TAB,
                    payload: {
                        tabId: formulaTab.id
                    }
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ITEM_BY_BARCODE,
                        params: {
                            barcode: payload.qrCode
                        }
                    },
                    method: handlers.GET_FORMULA_ITEMS_BY_BARCODE,
                    tabId: formulaTab.id
                }
            ];
        })
    );

const loadPackageImage = (action$, state$) =>
    action$.pipe(
        ofType(actionTypes.INTERGAMMA_SELECT_PACKAGE),
        switchMap(({payload}) => {
            if (
                payload.package === null ||
                state$.value.intergammaOrder.product === null ||
                state$.value.intergammaOrder.base === null
            ) {
                return [];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_PRODUCT_IMAGE,
                        params: {
                            productName: state$.value.intergammaOrder.product.name,
                            baseName: state$.value.intergammaOrder.base.name,
                            packageName: payload.package.name,
                            online: state$.value.settings.imagesSource === settings.SOURCE_ONLINE
                        }
                    },
                    method: handlers.INTERGAMMA_GET_PRODUCT_IMAGE,
                    tabId: 0
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_RECALCULATE_FORMULA,
                        params: {
                            formulaId: state$.value.intergammaOrder.formula.id,
                            formula: null,
                            formulaForCustomPackage: false,
                            baseInProductId: state$.value.intergammaOrder.base.baseInProductId,
                            baseInProductPackageId: state$.value.intergammaOrder.package.id,
                            customPackage: false,
                            customPackageSize: null,
                            customPackageUnit: null,
                            isLocal: state$.value.intergammaOrder.color.local
                        }
                    },
                    method: handlers.INTERGAMMA_RECALCULATE_FORMULA,
                    tabId: 0
                }
            ];
        })
    );

const databaseQuickSelect = (action$, state$) =>
    action$.pipe(
        ofType(actionTypes.INTERGAMMA_SELECT_DATABASE),
        switchMap(({payload}) => {
            if (payload.activeDatabase === payload.database.name) {
                return [
                    {
                        type: actionTypes.SET_ACTIVE_TAB_SCENE,
                        payload: {
                            tabId: state$.value.navigation.activeTab,
                            scene: componentTypes.COLOR_SCENE
                        }
                    }
                ];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_SET_ACTIVE_DATABASE,
                        params: {
                            name: payload.database.name,
                            autologin: true
                        }
                    },
                    method: handlers.INTERGAMMA_SET_ACTIVE_DATABASE,
                    tabId: state$.value.navigation.activeTab
                }
            ];
        })
    );

const reloadDataAfterDbChange = (action$) =>
    action$.pipe(
        ofType(
            actionTypes.INTERGAMMA_SET_ACTIVE_DATABASE,
            actionTypes.INTERGAMMA_SET_ACTIVE_DATABASE_AFTER_BARCODE,
            actionTypes.INTERGAMMA_SET_ACTIVE_DATABASE_AFTER_CIF_BARCODE
        ),
        switchMap(({payload}) => {
            if (payload.database === null) {
                return [];
            }

            return [
                {
                    type: actionTypes.DATABASE_CHANGE_GAMMA
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_USER_SETTINGS
                    },
                    method: handlers.RELOAD_USER_SETTINGS,
                    tabId: 0
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ALL_COLORANTS
                    },
                    method: handlers.RELOAD_ALL_COLORANTS,
                    tabId: 0
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ALL_PRODUCTS,
                        params: {
                            tree: false
                        }
                    },
                    method: handlers.RELOAD_GLOBAL_ALL_PRODUCTS_SIMPLE,
                    tabId: 0
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ALL_FANDECKS
                    },
                    method: handlers.RELOAD_GLOBAL_ALL_FANDECKS,
                    tabId: 0
                }
            ];
        })
    );

const resetColorWithFandeck = (action$, state$) =>
    action$.pipe(
        ofType(actionTypes.INTERGAMMA_RESET_COLOR_WITH_FANDECK),
        switchMap(() => {
            let fandeck = state$.value.intergammaOrder.fandeck;

            if (fandeck !== null) {
                return [];
            }

            return [];
        })
    );

const resetFandeckWithColor = (action$, state$) =>
    action$.pipe(
        ofType(actionTypes.INTERGAMMA_RESET_FANDECK_WITH_COLOR),
        switchMap(() => {
            let color = state$.value.intergammaOrder.color;

            if (color !== null) {
                return [];
            }

            return [];
        })
    );

const setLastCustomer = (action$) =>
    action$.pipe(
        ofType(actionTypes.INTERGAMMA_SET_LAST_CUSTOMER),
        switchMap(() => {
            return [
                {
                    type: actionTypes.NAVIGATION_CLOSE_MODAL,
                    payload: {
                        type: componentTypes.INTERGAMMA_CONFIRM_CUSTOMER_MODAL
                    }
                }
            ];
        })
    );

export default [
    loadHistoryOrder,
    loadPackageImage,
    databaseQuickSelect,
    reloadDataAfterDbChange,
    resetColorWithFandeck,
    resetFandeckWithColor,
    setLastCustomer
];
